export default "__VITE_ASSET__9311250c__"